import { useMutation, useQuery } from "@tanstack/react-query";

import {
  createForYouItem,
  deleteForYouItem,
  getForYouItems,
  getHomeSettings,
  getWeeklyMeditations,
  updateForYouItem,
  updateHomeSettings,
  updateWeeklyMeditations,
} from "@/api";

export const homeContentQueryKeys = {
  useForYouItems: () => ["home", "forYouItems"],
  useHomeSettings: () => ["home", "settings"],
  useWeeklyMeditations: () => ["home", "weeklyMeditations"],
  // Nested under the key above, so saving the weekly list refreshes it too.
  useLiveWeeklyMeditations: () => ["home", "weeklyMeditations", "live"],
};

export const useHomeContent = () => {
  const useForYouItems = () =>
    useQuery({
      queryFn: () => getForYouItems(),
      queryKey: homeContentQueryKeys.useForYouItems(),
    });

  const useHomeSettings = () =>
    useQuery({
      queryFn: () => getHomeSettings(),
      queryKey: homeContentQueryKeys.useHomeSettings(),
    });

  const useCreateForYouItem = () =>
    useMutation({ mutationFn: createForYouItem });

  const useUpdateForYouItem = () =>
    useMutation({ mutationFn: updateForYouItem });

  const useDeleteForYouItem = () =>
    useMutation({ mutationFn: deleteForYouItem });

  const useUpdateHomeSettings = () =>
    useMutation({ mutationFn: updateHomeSettings });

  const useWeeklyMeditations = () =>
    useQuery({
      queryFn: () => getWeeklyMeditations(true),
      queryKey: homeContentQueryKeys.useWeeklyMeditations(),
    });

  // What the app is actually showing right now, including the automatic list.
  const useLiveWeeklyMeditations = () =>
    useQuery({
      queryFn: () => getWeeklyMeditations(false),
      queryKey: homeContentQueryKeys.useLiveWeeklyMeditations(),
    });
  const useUpdateWeeklyMeditations = () =>
    useMutation({ mutationFn: updateWeeklyMeditations });

  return {
    useForYouItems,
    useHomeSettings,
    useCreateForYouItem,
    useUpdateForYouItem,
    useDeleteForYouItem,
    useUpdateHomeSettings,
    useWeeklyMeditations,
    useLiveWeeklyMeditations,
    useUpdateWeeklyMeditations,
  };
};
